import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";
import { Content } from "../../pages/Help";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

interface GetHelpMarkdownRequest {
  language: string;
}

export function useGetHelpMarkdown(callbacks: QueryCallbacks<Content>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationKey: ["getHelpMarkdown"],
    mutationFn: async (getHelpMarkdownRequest: GetHelpMarkdownRequest) => {
      return apiContext.utp2HelpApis.getMarkdown(getHelpMarkdownRequest.language);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
